;(function () {
    function Controller(wrapper) {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        this.wrapper = wrapper

        this.form = wrapper.querySelector('[rel="contact-person-type-of-entry-search--form"]')

        this.zipCodeInput = wrapper.querySelector('[rel="contact-person-type-of-entry-search--zipcode"]')

        this.place = _this.wrapper.querySelector('[rel="contact-person-type-of-entry-search--place"]')

        this.entryType = _this.wrapper.querySelector('[rel="contact-person-type-of-entry-search--type"]')

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            if (_this.zipCodeInput !== null) {
                _this.zipCodeInput.addEventListener('input', function (e) {
                    e.preventDefault()
                    let zipcode = _this.zipCodeInput.value
                    if (zipcode.toString().length >= 5) {
                        _this.searchForZipCode(zipcode.slice(0, 5), _this.renderResult)
                    }
                })
            }
            if (_this.form !== null) {
                if (_this.wrapper.dataset.mode !== null && _this.wrapper.dataset.mode === 'auto') {
                    // Disallow submitting the form in the backend
                    _this.form.addEventListener('submit', function (e) {
                        e.preventDefault()
                    })
                } else {
                    _this.form.addEventListener('submit', function (e) {
                        e.preventDefault()
                        let zipcode = _this.zipCodeInput.value
                        if (zipcode.toString().length >= 5) {
                            _this.searchForZipCode(zipcode.slice(0, 5), _this.renderResult)
                        }
                    })
                }
            }
        }

        /**
         * Searches for the given zipcode and passes the results to the callback
         *
         * @param zipcode
         * @param callback
         */
        this.searchForZipCode = function (zipcode, callback) {
            _this.wrapper.classList.add('loading')
            let url = _this.form.dataset.target + '?searchtype=' + _this.form.dataset.searchType + '&zipcode=' + zipcode
            var xmlHttp = new XMLHttpRequest()
            xmlHttp.onreadystatechange = function () {
                if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
                    callback(JSON.parse(xmlHttp.responseText))
                    _this.wrapper.classList.remove('loading')
                }
            }
            xmlHttp.open('GET', url, true) // true for asynchronous
            xmlHttp.send(null)
        }

        /**
         * Trigger the rendering for the result data
         *
         * @param data
         */
        this.renderResult = function (data) {
            // If Result is given, set Type of Entry "Installateureintrag" otherwise set "Gasteintrag"
            if (data && Object.keys(data).length > 0) {
                // This is a workaround because html_entitiy_decode is not working on server side.
                const tmpHtmlWrapper = document.createElement('div')
                tmpHtmlWrapper.innerHTML = data.city
                _this.place.value = tmpHtmlWrapper.innerHTML ?? '-'
                _this.entryType.value = 'Installateureintrag'
            } else {
                _this.place.value = '-'
                _this.entryType.value = 'Gasteintrag'
            }
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.EnergyContactPersonTypeOfEntrySearch = window.EnergyContactPersonTypeOfEntrySearch || {}

    window.EnergyContactPersonTypeOfEntrySearch.Controller = Controller
})()

/**
 * Initialize the type of entry script for each wrapper to allow multiple plugins on one page
 */
initializeTypeOfEntrySearch = function () {
    let forms = document.querySelectorAll('[rel="contact-person-type-of-entry-search"]')
    if (forms.length > 0) {
        forms.forEach(function (wrapper) {
            new window.EnergyContactPersonTypeOfEntrySearch.Controller(wrapper)
        })
    }
}

if (document.readyState !== 'loading') {
    initializeTypeOfEntrySearch()
} else {
    initializeTypeOfEntrySearch()
}
